import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e } from "../../../core/maybe.js";
import { defaults as t } from "./Settings.js";
import { squareDistance as r, anyMapPointToScreenPoint as s } from "./snappingUtils.js";

var i = /*#__PURE__*/function () {
  function i(e, r) {
    _classCallCheck(this, i);

    this.view = e, this.options = r, this.squaredShortLineThreshold = t.shortLineThreshold * t.shortLineThreshold;
  }

  _createClass(i, [{
    key: "snap",
    value: function snap(t, r) {
      return e(r.vertexHandle) ? "vertex" !== r.vertexHandle.type ? [] : this.snapExistingVertex(t, r) : this.snapNewVertex(t, r);
    }
  }, {
    key: "edgeExceedsShortLineThreshold",
    value: function edgeExceedsShortLineThreshold(e, t) {
      return this.exceedsShortLineThreshold(e.leftVertex.pos, e.rightVertex.pos, t);
    }
  }, {
    key: "exceedsShortLineThreshold",
    value: function exceedsShortLineThreshold(e, t, _ref) {
      var _i = _ref.elevationInfo,
          o = _ref.editGeometryOperations;
      var h = o.data.coordinateHelper;
      return 0 === this.squaredShortLineThreshold || r(s(t, h, _i, this.view), s(e, h, _i, this.view)) > this.squaredShortLineThreshold;
    }
  }, {
    key: "squaredProximityTreshold",
    value: function squaredProximityTreshold(e) {
      return "touch" === e ? this.squaredTouchProximityThreshold : this.squaredMouseProximityTreshold;
    }
  }, {
    key: "squaredMouseProximityTreshold",
    get: function get() {
      return this.options.distance * this.options.distance;
    }
  }, {
    key: "squaredTouchProximityThreshold",
    get: function get() {
      var _this$options = this.options,
          e = _this$options.distance,
          t = _this$options.touchSensitivityMultiplier,
          r = e * t;
      return r * r;
    }
  }]);

  return i;
}();

export { i as SnappingAlgorithm };